import { render, staticRenderFns } from "./new_service.vue?vue&type=template&id=aceb45a8&scoped=true&"
import script from "./new_service.vue?vue&type=script&lang=js&"
export * from "./new_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb45a8",
  null
  
)

export default component.exports